/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UsuarioObtenerPorFolderIdCompanyUserFolderGet$Params {
  Accept?: string;
}

export function usuarioObtenerPorFolderIdCompanyUserFolderGet(http: HttpClient, rootUrl: string, params?: UsuarioObtenerPorFolderIdCompanyUserFolderGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, usuarioObtenerPorFolderIdCompanyUserFolderGet.PATH, 'get');
  if (params) {
    rb.header('Accept', params.Accept, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

usuarioObtenerPorFolderIdCompanyUserFolderGet.PATH = '/usuario/obtener-por-folder/idCompanyUserFolder';
